<script lang="ts">
  import { addLog } from "../stores/LoggerStore";
  import type { Node } from "../scripts/FileTypes";
  import { onMount } from "svelte";
  import ProcMgr from "../stores/ProcMgr";
  import SettingsMgr from "../stores/SettingsMgr";
  import type { Theme } from "../scripts/WinTypes";
  export let fileNode: Node;
  export let onIconClick = (node: Node) => {
    addLog("on icon click : " + node.path.path + ", cmd : " + node.exeCmd);
    ProcMgr.getInstance().exeFile(node.path);
  };
  let src, contElem: HTMLElement, highElem: HTMLElement, descElem: HTMLElement;

  const thememgr = SettingsMgr.getInstance();
  const _theme = thememgr.theme;
  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    contElem.style.setProperty("color", c["1"]);
    // contElem.style.setProperty("background-color", c["2"]);
    // titleElem.style.setProperty("color", c["1"]);
    highElem.style.setProperty(
      "background",
      `linear-gradient(135deg, ${c["1"]} 25%, ${c["2"]} 60%, ${c["3"]})`
    );
    descElem.style.setProperty("background-color", `${c["2"] + "cc"}`);
  };
  $: watcher = themeWatcher($_theme);

  const width = 90;
  const style = `width:${width}px;height:${width}px;border-radius:${
    width / 2
  }px`;

  onMount(() => {
    watcher = themeWatcher($_theme);
    src = fileNode.iconPath;
  });
  const abbreviate = (path: string) => {
    const max = 15;
    return path.slice(0, max) + (path.length > max ? "..." : "");
  };

  let hovered = false;
  const hoverIn = () => {
    hovered = true;
    contElem.style.overflow = "show";
  };
  const hoverOut = () => {
    hovered = false;
    contElem.style.overflow = "hidden";
  };
</script>

<div
  class="container"
  bind:this={contElem}
  on:click={() => {
    onIconClick(fileNode);
  }}
  on:mouseenter={hoverIn}
  on:mouseleave={hoverOut}
>
  <span class="highlight" bind:this={highElem} />
  <div class="img-container" {style}>
    <img {src} alt={`${fileNode?.path.last} image`} class="window-icon" />
  </div>
  <div class="desc" bind:this={descElem}>
    {hovered ? fileNode?.path.last : abbreviate(fileNode?.path.last)}
  </div>
</div>

<style>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    display: flex;
    overflow: hidden;
    /* background-color: blue; */
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    transition: 0.2s;
    user-select: none;
  }

  .highlight {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 0%;
    transition: 0.2s;
    opacity: 0.3;
  }
  .container:hover .highlight {
    width: 100%;
  }
  .container:hover {
    box-shadow: 1px 1px 3px #333;
    transform: translate(-2px, -2px);
  }
  .container:active {
    box-shadow: 0px 0px 0px;
    transform: translate(0px, 0px);
    transition: 0.05s;
  }
  .container:active .highlight {
    transition: 0.05s;
  }
  .img-container,
  .desc {
    position: relative;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .desc {
    word-break: break-all;
    /* width: 100%; */
    margin: 0 auto;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 1.2rem;
    font-weight: 500;
    font-family: "Noto Sans", sans-serif;
    text-align: center;
    /* text-shadow: 1px 1px 1px #888; */
    direction: ltr;
  }

  .window-icon {
    display: inline-block;
    border-radius: 5px;
    width: 70%;
    height: 70%;
    /* background-color: #dbdbdb; */
    object-fit: contain;
    object-position: center center;
  }
</style>
